import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {RoleService} from "../../service/RoleService.ts";
import {ReadRoleResponse, ReadRoleResponseData} from "../../model/response/role/ReadRoleResponse.ts";

export type RoleState = {
    loading: boolean;
    roles: ReadRoleResponseData[]
};

const initialState: RoleState = {
    loading: false,
    roles: []
};

const action = {
    read: createAsyncThunk(
        "role/read",
        async (_, thunkAPI) => {
            return (await RoleService.read(thunkAPI)).data;
        }
    ),
};

const slice = createSlice({
    name: "role",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.read.pending, (state) => {
                state.loading = true;
            })
            .addCase(action.read.fulfilled, (state, action) => {
                const response = action.payload as ReadRoleResponse;
                state.loading = false;
                if (response.responseCode === "00")
                    state.roles = response.data
            });
    },
});

export const roles = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
